"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.StyledFormSectionBase = styled_components_1.default.div(function (props) {
    var backgroundColor = props.backgroundColor, summary = props.summary;
    return "\n    background-color: " + backgroundColor + ";\n    margin-top:  " + (summary ? '0' : '10px') + ";\n    margin-bottom: " + (summary ? '10px' : '20px') + ";\n\n    .FormSectionBase:first-child {\n      margin-top: 0;\n    }\n\n    .FormSectionBase:last-child {\n      margin-top: 20px;\n    }\n  ";
});
//# sourceMappingURL=StyledFormSectionBase.js.map